import { motion } from "framer-motion";
import { ArrowRight, Search, UserCheck, Users } from "lucide-react";

import Button from "../../Button/Button";
import Container from "../../Container/Container";
import { fadeLeft, fadeRight, floating, viewportOnce } from "../../../Utils/animations";

import "../../../Style/home/recruitment.css";

const candidates = [
  { id: 1, role: "Senior Data Analyst", match: "96%" },
  { id: 2, role: "Growth Marketing Lead", match: "91%" },
  { id: 3, role: "Enterprise Account Exec", match: "89%" },
];

/** Recruitment / staffing section with a candidate-pipeline card. */
function Recruitment() {
  return (
    <section className="section section--tint recruitment">
      <Container className="recruitment__grid">
        <motion.div
          className="recruitment__visual"
          variants={fadeLeft()}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <motion.div className="recruitment__panel" {...floating(9, 5.5)}>
            <div className="recruitment__panel-head">
              <Search size={16} />
              <span>Candidate Pipeline</span>
            </div>

            <div className="recruitment__list">
              {candidates.map((candidate) => (
                <div key={candidate.id} className="recruitment__card">
                  <span className="recruitment__avatar">
                    <UserCheck size={18} />
                  </span>
                  <div>
                    <p className="recruitment__role">{candidate.role}</p>
                    <span className="recruitment__match">{candidate.match} match</span>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div className="recruitment__badge" {...floating(6, 4)}>
            <Users size={18} />
            <div>
              <strong>120+</strong>
              <span>Placements this year</span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="recruitment__copy"
          variants={fadeRight(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <span className="section-eyebrow">
            <span className="section-eyebrow__dot" aria-hidden="true" />
            Recruitment & Staffing
          </span>
          <h2 className="section-title mt-4">
            Your trusted partner in <span className="text-gradient">recruitment & staffing.</span>
          </h2>
          <p className="section-description mt-4">
            Finding the right talent for your organization is crucial for success. In today's
            competitive job market, we connect businesses with the candidates that fit both the
            role and the team.
          </p>
          <Button
  icon={<ArrowRight size={18} />}
  className="mt-6"
  onClick={() => {
    window.history.pushState({}, "", "/recruitment");
    window.dispatchEvent(new Event("popstate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
>
  Find Talent
</Button>
        </motion.div>
      </Container>
    </section>
  );
}

export default Recruitment;
